import 'select2/dist/js/select2.full.min';

const underwriterSelect = {
    activeSection:0,
    select: false,
    init:() => {
        //only init if the options are set
        if(typeof underwriterOptions !== 'undefined'){
            $('.underwriter-button').on('click', (e) => {
                //get btn clicked and grab IDs
                var btn = $(e.target);
                var id = btn.attr('data-underwriter-set');
    
                underwriterSelect.toggleActiveSection(btn);
    
                // set active section id
                underwriterSelect.activeSection = parseInt(id);
                //clear select options
                underwriterSelect.select.select2().empty();
                //redraw select
                underwriterSelect.renderSelect(underwriterOptions[underwriterSelect.activeSection]);
            });
    
            // render select initialy
            underwriterSelect.renderSelect(underwriterOptions[underwriterSelect.activeSection]);
        }
        
        
    },
    toggleActiveSection(btn){
        $('.underwriter-button').each((i,target) => {
            var button = $(target);
            button.removeClass('btn-evergarden-white-outline');
            if(!button.hasClass('btn-grey-white-outline')){
                button.addClass('btn-grey-white-outline')
            }
            
        });

        //set active button after loop
        btn.removeClass('btn-grey-white-outline');
        btn.addClass('btn-evergarden-white-outline');
    },
    renderSelect:(data) => {
        underwriterSelect.select = $('.underwriter_select').prepend('<option></option>').select2({
            width:'100%',
            dropdownParent: $('.select-wrap'),
            placeholder:'Please select',
            data:data,
            
        });

        underwriterSelect.select.on('select2:select', (e) => {
            if(underwriters[underwriterSelect.activeSection][e.target.value].new_window === "1"){
                window.open(underwriters[underwriterSelect.activeSection][e.target.value].link);
            }else{
                window.location.href = underwriters[underwriterSelect.activeSection][e.target.value].link;
            }
        });
    }
};

export default underwriterSelect;